import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import { Row, Col, Form, FormGroup, Label, Input, Button, CustomInput, Table } from "reactstrap";
import { getTransFunc } from '../../../Basic/SFxLocalization';
import { getCountry, getProvince } from "../../api";
import { userData } from "../data";
import CommonSelect from "../../../Basic/Select";
import { IconLock, IconEditCustom, IconDelete, IconPlusCircleOutline } from "@sfx/icons";
import { scrollToSelect } from "../../utils/utils";
import { cloneDeep } from 'lodash';
var prefix = "sfx-react-ui-user-profile";

var Addresses = /*#__PURE__*/function (_React$Component) {
  _inherits(Addresses, _React$Component);

  var _super = _createSuper(Addresses);

  function Addresses(props) {
    var _this;

    _classCallCheck(this, Addresses);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.setState = function () {
        return;
      };
    });

    _defineProperty(_assertThisInitialized(_this), "getProvinceList", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(geonameId) {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setState({
                  isProvinceLoading: true
                });

                _context.next = 3;
                return getProvince(geonameId);

              case 3:
                res = _context.sent;

                _this.setState({
                  isProvinceChangeAble: true,
                  isProvinceLoading: false
                });

                return _context.abrupt("return", res);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "resetData", function () {
      var tableList = userData.addressInfo ? cloneDeep(userData.addressInfo) : [];

      _this.setState({
        tableList: tableList,
        checked: !!tableList.filter(function (i) {
          return i.main;
        }).length
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getBaseInfo", function (fun) {
      Object.values(fun).forEach(function (f, n) {
        f().then(function (res) {
          var data = res.data; // eslint-disable-next-line

          var name = Object.keys(fun)[n];
          userData.staticSource[name] = data;

          _this.setState(_defineProperty({}, name, data));
        }).catch(function (error) {
          console.log(error);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setMainAddress", function (e) {
      if (!userData.mainAddress) return;
      var mainAddress = userData.mainAddress;
      mainAddress.main = true;
      var tableList = _this.state.tableList;

      if (e.target.checked) {
        tableList.unshift(mainAddress);

        _this.setState({
          tableList: tableList,
          checked: e.target.checked
        });
      } else {
        tableList = tableList.filter(function (i) {
          return !i.main;
        });

        _this.setState({
          tableList: tableList,
          checked: e.target.checked
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "saveAddress", function () {
      var tableList = _this.state.tableList;
      var _this$state = _this.state,
          formAddress = _this$state.formAddress,
          formType = _this$state.formType;

      if (formType === "Add") {
        tableList.push(formAddress);
      } else {
        tableList = tableList.map(function (n) {
          return n._id === formAddress._id ? formAddress : n;
        });
      }

      tableList.forEach(function (n, i) {
        if (!n._id) {
          n._id = i;
        }
      });

      _this.setState({
        tableList: tableList,
        showForm: false,
        formAddress: {}
      });

      _this.props.setDisableState(false);
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectChange", function (item, name) {
      var formAddress = Object.assign(_this.state.formAddress, _defineProperty({}, name, item));

      _this.setState({
        formAddress: formAddress
      }, function () {
        var obj = {};

        switch (name) {
          case "country":
            _this.getBaseInfo({
              provinceList: function provinceList() {
                return _this.getProvinceList(item.geonameId);
              }
            });

            obj = Object.assign(_this.state.formAddress, {
              province: null
            }, {
              city: ""
            });

            _this.setState({
              formAddress: obj,
              isProvinceChangeAble: false,
              isCityChangeAble: false
            });

            break;

          default:
            break;
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (e) {
      var _e$target = e.target,
          name = _e$target.name,
          value = _e$target.value;
      var formAddress = Object.assign(_this.state.formAddress, _defineProperty({}, name, value));

      _this.setState({
        formAddress: formAddress
      });
    });

    _defineProperty(_assertThisInitialized(_this), "editAddress", function (e, item) {
      if (item.country && item.country.geonameId) {
        var countryId = item.country.geonameId;

        _this.getBaseInfo({
          provinceList: function provinceList() {
            return _this.getProvinceList(countryId);
          }
        });
      }

      _this.setState({
        showForm: true,
        formAddress: _objectSpread({}, item),
        formType: "Update"
      }, function () {
        _this.scrollToAnchor();
      });

      _this.props.setDisableState(true);
    });

    _defineProperty(_assertThisInitialized(_this), "deleteAddress", function (e, item) {
      var tableList = _this.state.tableList;
      tableList = tableList.filter(function (i) {
        return i._id !== item._id;
      });

      _this.setState({
        tableList: tableList
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addAddress", function () {
      _this.setState({
        showForm: true,
        formType: "Add"
      }, function () {
        _this.scrollToAnchor();
      });

      _this.props.setDisableState(true);
    });

    _defineProperty(_assertThisInitialized(_this), "scrollToAnchor", function () {
      var anchorElement = document.getElementById("addressAnchor");

      if (anchorElement) {
        anchorElement.scrollIntoView({
          block: "end",
          behavior: "smooth"
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "saveData", function () {
      userData.addressInfo = _toConsumableArray(_this.state.tableList);
    });

    _this.state = {
      tableList: cloneDeep(userData.addressInfo) || [],
      countryList: userData.staticSource.countryList || [],
      provinceList: [],
      isProvinceChangeAble: false,
      isProvinceLoading: false,
      isCityChangeAble: false,
      showForm: false,
      formAddress: {},
      formType: "Add",
      checked: false
    };
    return _this;
  }

  _createClass(Addresses, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.childEvent({
        saveData: this.saveData,
        resetData: this.resetData
      });

      if (!userData.staticSource.countryList) {
        this.getBaseInfo({
          countryList: getCountry
        });
      }

      this.resetData();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var trans = getTransFunc();
      var _this$state$formAddre = this.state.formAddress,
          addressName = _this$state$formAddre.addressName,
          address = _this$state$formAddre.address,
          city = _this$state$formAddre.city,
          zipCode = _this$state$formAddre.zipCode,
          country = _this$state$formAddre.country;
      var canSubmit = country && addressName && addressName.trim() && address && address.trim() && city && city.trim() && zipCode && zipCode.trim();
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          justifyContent: "space-between"
        }
      }, /*#__PURE__*/React.createElement("span", null, trans('SFxUserProfileSetMainCompanyAddress')), /*#__PURE__*/React.createElement(CustomInput, {
        type: "switch",
        id: "setMainAddress",
        name: "setMainAddress",
        inline: true,
        onChange: this.setMainAddress,
        checked: this.state.checked
      })), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement("tbody", null, this.state.tableList.map(function (i) {
        return /*#__PURE__*/React.createElement("tr", {
          key: i._id,
          className: i._id === _this2.state.formAddress._id && _this2.state.formType === "Update" ? "activeItem" : ""
        }, /*#__PURE__*/React.createElement("td", null, i.addressName && i.addressName), /*#__PURE__*/React.createElement("td", null, i.address ? "".concat(i.address, ", ") : "", i.addressLine2 ? "".concat(i.addressLine2, ", ") : "", i.city ? "".concat(i.city, ", ") : "", i.province && i.province.name ? "".concat(i.province.name, ", ") : "", i.zipCode ? "".concat(i.zipCode, ", ") : "", i.country && i.country.countryName), /*#__PURE__*/React.createElement("td", {
          style: {
            textAlign: "right"
          }
        }, /*#__PURE__*/React.createElement("span", {
          style: {
            display: "flex",
            justifyContent: "flex-end"
          }
        }, i.main ? /*#__PURE__*/React.createElement(IconLock, {
          size: "18",
          className: "".concat(prefix, "-icon-wrap")
        }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
          onClick: function onClick(e) {
            return _this2.editAddress(e, i);
          }
        }, /*#__PURE__*/React.createElement(IconEditCustom, {
          size: "18",
          className: "".concat(prefix, "-icon-wrap")
        })), /*#__PURE__*/React.createElement("span", {
          onClick: function onClick(e) {
            return _this2.deleteAddress(e, i);
          }
        }, /*#__PURE__*/React.createElement(IconDelete, {
          className: "".concat(prefix, "-icon-wrap"),
          size: "18"
        }))))));
      }))), !this.state.showForm && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-icon-wrap"),
        onClick: this.addAddress
      }, /*#__PURE__*/React.createElement(IconPlusCircleOutline, {
        size: "18"
      }), "\xA0", trans('SFxUserProfileAddAddress')), this.state.showForm && /*#__PURE__*/React.createElement(Form, {
        id: "addressAnchor",
        style: {
          paddingBottom: "16px"
        }
      }, /*#__PURE__*/React.createElement(Row, {
        form: true
      }, /*#__PURE__*/React.createElement(Col, {
        md: "6"
      }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
        for: "addressName"
      }, trans('SFxUserProfileAddressName')), !(this.state.formAddress.addressName && this.state.formAddress.addressName.trim()) && /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefix, "-require")
      }, "*"), /*#__PURE__*/React.createElement(Input, {
        type: "text",
        name: "addressName",
        value: this.state.formAddress.addressName,
        onChange: this.onInputChange,
        maxLength: 50
      }))), /*#__PURE__*/React.createElement(Col, {
        md: "6"
      }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
        for: "address"
      }, trans('SFxUserProfileAddress')), !(this.state.formAddress.address && this.state.formAddress.address.trim()) && /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefix, "-require")
      }, "*"), /*#__PURE__*/React.createElement(Input, {
        type: "text",
        name: "address",
        value: this.state.formAddress.address,
        onChange: this.onInputChange,
        maxLength: 50
      }))), /*#__PURE__*/React.createElement(Col, {
        md: "6"
      }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
        for: "addressLine2"
      }, trans('SFxUserProfileAddressLine2')), /*#__PURE__*/React.createElement(Input, {
        type: "text",
        name: "addressLine2",
        value: this.state.formAddress.addressLine2,
        onChange: this.onInputChange,
        maxLength: 50
      }))), /*#__PURE__*/React.createElement(Col, {
        md: "6"
      }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
        for: "country"
      }, trans('SFxUserProfileCountry')), !this.state.formAddress.country && /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefix, "-require")
      }, "*"), /*#__PURE__*/React.createElement(CommonSelect, {
        onMenuOpen: function onMenuOpen() {
          scrollToSelect();
        },
        renderOption: function renderOption(i) {
          return {
            label: i.countryName,
            value: i.geonameId
          };
        },
        showFlag: true,
        value: this.state.formAddress.country,
        options: this.state.countryList,
        onChange: function onChange(item) {
          return _this2.onSelectChange(item, "country");
        }
      }))), /*#__PURE__*/React.createElement(Col, {
        md: "6"
      }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
        for: "province"
      }, trans('SFxUserProfileStateOrProvince')), /*#__PURE__*/React.createElement(CommonSelect, {
        onMenuOpen: function onMenuOpen() {
          scrollToSelect();
        },
        renderOption: function renderOption(i) {
          return {
            label: i.name,
            value: i.geonameId
          };
        },
        value: this.state.formAddress.province,
        isDisabled: !this.state.isProvinceChangeAble,
        isLoading: this.state.isProvinceLoading,
        options: this.state.formAddress.country ? this.state.provinceList : [],
        onChange: function onChange(item) {
          return _this2.onSelectChange(item, "province");
        }
      }))), /*#__PURE__*/React.createElement(Col, {
        md: "6"
      }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
        for: "city"
      }, trans('SFxUserProfileCity')), !(this.state.formAddress.city && this.state.formAddress.city.trim()) && /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefix, "-require")
      }, "*"), /*#__PURE__*/React.createElement(Input, {
        type: "text",
        name: "city",
        value: this.state.formAddress.city,
        onChange: this.onInputChange,
        maxLength: 50
      }))), /*#__PURE__*/React.createElement(Col, {
        md: "6"
      }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
        for: "zipCode"
      }, trans('SFxUserProfileZipOrPostCode')), !(this.state.formAddress.zipCode && this.state.formAddress.zipCode.trim()) && /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefix, "-require")
      }, "*"), /*#__PURE__*/React.createElement(Input, {
        type: "text",
        name: "zipCode",
        value: this.state.formAddress.zipCode,
        onChange: this.onInputChange,
        maxLength: 20
      }))), /*#__PURE__*/React.createElement(Col, {
        xs: "12",
        style: {
          textAlign: "right"
        }
      }, /*#__PURE__*/React.createElement(Button, {
        size: "sm",
        onClick: function onClick() {
          _this2.setState({
            showForm: false,
            formAddress: {}
          });

          _this2.props.setDisableState(false);
        }
      }, trans('SFxUserProfileCancel')), /*#__PURE__*/React.createElement(Button, {
        size: "sm",
        color: "primary",
        style: {
          marginLeft: "20px"
        },
        disabled: !canSubmit,
        onClick: this.saveAddress
      }, this.state.formType, " ", trans('SFxUserProfileAddress'))))));
    }
  }]);

  return Addresses;
}(React.Component);

export { Addresses as default };